// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-user-vuln-notification.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-user-vuln-notification',
  title: 'Notify affected users of actively exploited vulnerabilities and corrective measures',
  description:
    'Confirm that, after a manufacturer has reported an actively exploited vulnerability or a severe incident under CRA Art. 14(1)–(3), the manufacturer informs the users of the affected products with digital elements about the incident and, where appropriate, the corrective or mitigating measures the users can deploy (Art. 14(8)). Communications go out without undue delay, are written so non-technical users can act, include any in-product advisory messaging accompanying a security update under Annex I, Part II §8, and (where appropriate) inform the public. Review the user-notification template, the distribution channel, the timing record, and the relationship to the CVD policy.',
  category: 'incidents',
  scfIds: ['SCF-INC-004', 'SCF-PPL-008'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'User vulnerability notification procedure is published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
